import { render } from "./ModulesListDialog.vue?vue&type=template&id=36205632&scoped=true"
import script from "./ModulesListDialog.vue?vue&type=script&lang=js"
export * from "./ModulesListDialog.vue?vue&type=script&lang=js"

import "./ModulesListDialog.vue?vue&type=style&index=0&id=36205632&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36205632"]])

export default __exports__